

























































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { Pagination } from '../../mixins/pagination'
import { SearchItemType, TableColumnItemType, OperationItemType, OptionItemType, FillInfoItemOfForm } from '../../types/type'
import { CommonModule, UserModule, CanteenModule } from '../../store'
import { getAllFatherNodeForTree, disposeSearchParamsForCM, findItemForTree, disposeFillInfoToParamsForCM, getNameTextInOptions } from '../../utils/toolsForCommon'
@Component({
  name: 'IncomeAndExpenses',
  mixins: [Pagination],
  components: {
    'search-module': () => import('../../components/common/searchModule.vue'),
    'concise-card-have-title-acquiescent': () => import('../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'table-module': () => import('../../components/common/tableModule.vue'),
    'my-dialog': () => import('../../components/common/myDialog.vue')
  }
})
export default class IncomeAndExpenses extends Vue {
  public loading = false
  // 搜索条件的最终选中项：
  public searchCheckList: Array<string> = []
  // 所有搜索条件：
  public searchList: Array<SearchItemType> = [
    {
      title: '学校',
      key: 'organizationName',
      type: 'cascader',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      show: true,
      disabled: true
    },
    {
      title: '日期',
      key: 'dateInterval',
      type: 'dateForDaterange',
      value: '',
      placeholder: '请选择日期',
      show: true,
      disabled: false
    },
    {
      title: '摘要',
      key: 'summary',
      type: 'input',
      value: '',
      placeholder: '请输入摘要',
      show: true,
      disabled: false
    },
    {
      title: '科目',
      key: 'subject',
      type: 'cascaderForcode',
      value: '',
      placeholder: '请选择科目',
      treeData: [],
      show: true,
      disabled: false
    },
    {
      title: '收支形式',
      key: 'incOrExp',
      type: 'select',
      value: '',
      placeholder: '请选择收支形式',
      selectOptions: [],
      show: true,
      disabled: false
    },
    {
      title: '资金形式',
      key: 'capitalType',
      type: 'cascaderForcode',
      // 这个是新加的：
      // 为了只能选择末节点：
      props: {
        expandTrigger: 'click',
        children: 'children',
        label: 'name',
        checkStrictly: false,
        value: 'code'
      },
      value: '',
      placeholder: '请选择资金形式',
      treeData: [],
      show: true,
      disabled: false
    }
  ]
  // 列表列有哪些：
  public tableColumnList: Array<TableColumnItemType> = [
    {
      title: '时间',
      key: 'time',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '180px'
    },
    {
      title: '学校',
      key: 'orgId',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum',
      width: '200px'
    },
    {
      title: '摘要',
      key: 'summary',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    },
    {
      title: '科目',
      key: 'subject',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum',
      width: '200px'
    },
    {
      title: '收支形式',
      key: 'incOrExp',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum'
    },
    {
      title: '资金形式',
      key: 'capitalType',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      needTransformForResult: 'enum',
      width: '200px'
    },
    {
      title: '金额（元）',
      key: 'money',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '150px'
    },
    {
      title: '数量',
      key: 'amount',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '单位',
      key: 'unit',
      type: 'text',
      showStateForTableHeader: 'unilaminar'
    },
    {
      title: '备注',
      key: 'comment',
      type: 'text',
      showStateForTableHeader: 'unilaminar',
      width: '200px'
    }
  ]
  // 列表每一行的操作有哪些：
  public columnOperationList: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '编辑',
      key: 'update',
      type: 'primary',
      size: 'mini'
    },
    {
      title: '删除',
      key: 'delete',
      type: 'danger',
      size: 'mini'
    }
  ]
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-tickets m_r5'></span>生成凭证",
      key: 'generateVoucher',
      type: 'primary',
      size: ''
    },
    {
      title: "<span class='el-icon-delete m_r5'></span>清除凭证",
      key: 'emptyVoucher',
      type: 'danger',
      size: ''
    },
    {
      title: "<span class='el-icon-tickets m_r5'></span>生成科目余额表",
      key: 'getJournalGenerateSubjectBalanceForm',
      type: 'primary',
      size: ''
    },
    {
      title: "<span class='el-icon-delete m_r5'></span>清除科目余额表",
      key: 'emptySubjectBalanceForm',
      type: 'danger',
      size: ''
    },
    {
      title: "<span class='el-icon-menu m_r5'></span>更多操作",
      key: 'moreOperation',
      type: 'primary',
      size: ''
    },
    {
      title: "<span class='el-icon-bottom'></span>导出当前页收支流水列表",
      key: 'exportExcel',
      type: 'primary',
      size: '',
      canExportOutFlag: true,
      titleCopy: "<span class='el-icon-bottom'></span>导出当前页收支流水列表",
      exportResultFileName: '收支流水列表.xlsx',
      exportLoading: "<span class='el-icon-loading'></span>正在导出中，请稍后",
      exportError: '抱歉，导出失败',
      exportSuccess: '导出成功'
    }
  ]
  // 枚举选项：
  public optionsForIncOrExp: Array<OptionItemType> = [
    {
      name: '收入',
      value: true
    },
    {
      name: '支出',
      value: false
    }
  ]
  // 生成凭证相关：
  public dialogFlagForGenerateVoucher: boolean = false
  public loadingForGenerateVoucher: boolean = false
  public informationGenerateVoucher: Array<FillInfoItemOfForm> = [
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationNameForIncomeAndExpenses',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      content: '',
      disabled: false,
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '月份',
      type: 'dateForYearMonth',
      key: 'targetMonthForIncomeAndExpenses',
      value: '',
      placeholder: '请选择月份',
      content: '',
      disabled: false,
      isNecessary: true
    }
  ]
  // 生成科目余额表相关：
  public dialogFlagForGetJournalGenerateSubjectBalanceForm: boolean = false
  public loadingForGetJournalGenerateSubjectBalanceForm: boolean = false
  public informationGetJournalGenerateSubjectBalanceForm: Array<FillInfoItemOfForm> = [
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationNameForIncomeAndExpenses',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      content: '',
      disabled: false,
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '月份',
      type: 'dateForYearMonth',
      key: 'targetMonthForIncomeAndExpenses',
      value: '',
      placeholder: '请选择月份',
      content: '',
      disabled: false,
      isNecessary: true
    }
  ]
  // 清除凭证：
  // 直接就用生成凭证的弹框
  public titleForDialogFlagForGenerateVoucher: string = ''
  // 生成科目余额表：
  // 直接就用生成科目余额表的弹框
  public titleForDialogFlagForGetJournalGenerateSubjectBalanceForm: string = ''
  // 更多操作：
  public dialogFlagForMoreOperation: boolean = false
  // 结转：
  public dialogFlagForCarryOver: boolean = false
  public loadingForCarryOver: boolean = false
  public informationCarryOver: Array<FillInfoItemOfForm> = [
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationNameForIncomeAndExpenses',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      content: '',
      disabled: false,
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '月份',
      type: 'dateForYearMonth',
      key: 'targetMonthForIncomeAndExpenses',
      value: '',
      placeholder: '请选择月份',
      content: '',
      disabled: false,
      isNecessary: true
    }
  ]
  public titleForDialogFlagForCarryOver: string = ''
  // 总账明细账相关：
  public dialogFlagForCommon: boolean = false
  public loadingForCommon: boolean = false
  public informationCommon: Array<FillInfoItemOfForm> = [
    {
      title: '学校',
      type: 'cascader',
      key: 'organizationNameForIncomeAndExpenses',
      value: '',
      placeholder: '请选择学校',
      treeData: [],
      content: '',
      disabled: false,
      isNecessary: true,
      temporaryStorageForValue: null
    },
    {
      title: '年份',
      type: 'dateForYear',
      key: 'targetYearForIncomeAndExpenses',
      value: '',
      placeholder: '请选择年份',
      content: '',
      disabled: false,
      isNecessary: true
    }
  ]
  public titleForDialogFlagForCommon: string = ''

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get userInfo () {
    return UserModule.userInfo
  }

  get btnTypeAboutVoucher () {
    let btnTypeAboutVoucher = ''
    switch (this.titleForDialogFlagForGenerateVoucher) {
      case '生成凭证':
        btnTypeAboutVoucher = 'primary'
        break
      case '清除凭证':
        btnTypeAboutVoucher = 'danger'
        break
    }
    return btnTypeAboutVoucher
  }

  get btnTypeAboutSubjectBalanceForm () {
    let btnTypeAboutSubjectBalanceForm = ''
    switch (this.titleForDialogFlagForGetJournalGenerateSubjectBalanceForm) {
      case '生成科目余额表':
        btnTypeAboutSubjectBalanceForm = 'primary'
        break
      case '清除科目余额表':
        btnTypeAboutSubjectBalanceForm = 'danger'
        break
    }
    return btnTypeAboutSubjectBalanceForm
  }

  get btnTypeAboutCarryOver () {
    let btnTypeAboutCarryOver = ''
    switch (this.titleForDialogFlagForCarryOver) {
      case '结转':
        btnTypeAboutCarryOver = 'primary'
        break
      case '清除结转数据':
        btnTypeAboutCarryOver = 'danger'
        break
    }
    return btnTypeAboutCarryOver
  }

  get btnTypeAboutCommon () {
    let btnTypeAboutCommon = ''
    switch (this.titleForDialogFlagForCommon) {
      case '生成总账':
      case '生成明细账':
        btnTypeAboutCommon = 'primary'
        break
      case '清空总账':
      case '清空明细账':
        btnTypeAboutCommon = 'danger'
        break
    }
    return btnTypeAboutCommon
  }

  async mounted () {
    await Promise.all([
      CommonModule.getTreeDataForOrganization(),
      CommonModule.getTreeDataForSubOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    this.disposeSearchCheckedInit()
    this.disposeForSearchList()
    this.disposeForFillInfoList()
    this.getTableDataList()
  }

  activated () {
    const { refresh } = this.$route.query
    if (refresh === '1') {
      this.getTableDataList()
    }
  }

  // 选择项初始化：
  disposeSearchCheckedInit () {
    // this.searchCheckList = this.searchList.length > 2 ? this.searchList.slice(0, 2).map(item => item.key) : this.searchList.slice(0).map(item => item.key)
    this.searchCheckList = this.searchList.slice(0).map(item => item.key)
  }

  // 选择项数据处理：
  disposeForSearchList () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'organizationName':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
        case 'subject':
        case 'capitalType':
          item.treeData = this.treeDataForDisposeNameSubject
          break
        case 'incOrExp':
          item.selectOptions = this.optionsForIncOrExp
          break
      }
      return item
    })
  }

  // 选择框数据处理--form
  disposeForFillInfoList () {
    this.informationGenerateVoucher = this.informationGenerateVoucher.map(item => {
      switch (item.key) {
        case 'organizationNameForIncomeAndExpenses':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
      }
      return item
    })
    this.informationGetJournalGenerateSubjectBalanceForm = this.informationGetJournalGenerateSubjectBalanceForm.map(item => {
      switch (item.key) {
        case 'organizationNameForIncomeAndExpenses':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
      }
      return item
    })
    this.informationCarryOver = this.informationCarryOver.map(item => {
      switch (item.key) {
        case 'organizationNameForIncomeAndExpenses':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
      }
      return item
    })
    this.informationCommon = this.informationCommon.map(item => {
      switch (item.key) {
        case 'organizationNameForIncomeAndExpenses':
          item.treeData = this.treeDataForSubOrganatizion
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          item.temporaryStorageForValue = findItemForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
      }
      return item
    })
  }

  incomeAndExpensesAddOrUpdate (id: string, orgId: string) {
    this.$router.push({
      name: 'AddOrUpdateIncomeAndExpenses',
      query: {
        id,
        orgId
      }
    })
  }

  // 操作按钮：
  operationForButton ({ key }, { id, orgId }) {
    switch (key) {
      case 'detail':
        this.$router.push({
          name: 'IncomeAndExpensesDetail',
          query: {
            id,
            orgId
          }
        })
        break
      case 'update':
        this.incomeAndExpensesAddOrUpdate(id, orgId)
        break
      case 'delete':
        this.operationForDelete(id)
        break
      case 'generateVoucher':
        this.dialogFlagForGenerateVoucher = true
        this.titleForDialogFlagForGenerateVoucher = '生成凭证'
        break
      case 'emptyVoucher':
        this.dialogFlagForGenerateVoucher = true
        this.titleForDialogFlagForGenerateVoucher = '清除凭证'
        break
      case 'getJournalGenerateSubjectBalanceForm':
        this.dialogFlagForGetJournalGenerateSubjectBalanceForm = true
        this.titleForDialogFlagForGetJournalGenerateSubjectBalanceForm = '生成科目余额表'
        break
      case 'emptySubjectBalanceForm':
        this.dialogFlagForGetJournalGenerateSubjectBalanceForm = true
        this.titleForDialogFlagForGetJournalGenerateSubjectBalanceForm = '清除科目余额表'
        break
      case 'moreOperation':
        this.dialogFlagForMoreOperation = true
        break
      case 'exportExcel':
        // 开始导出：纯前端导出
        this.operationForButtonOfTableHeader.forEach(async item => {
          if (item.key === 'exportExcel') {
            if (!item.canExportOutFlag) return this.$message.error('请等待上一次请求完成！')
            item.canExportOutFlag = false
            item.title = item.exportLoading
            // start:
            const keysList = this.tableColumnList.map(v => v.key)
            const dataRes = ((this as any).tableDataList || []).map(v => {
              return keysList.map(vv => {
                let res = ''
                switch (vv) {
                  case 'orgId':
                    const NodeRes = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', v[vv])
                    if (!Object.keys(NodeRes).length) {
                      res = '- -'
                    } else {
                      res = NodeRes['name']
                    }
                    break
                  case 'subject':
                    res = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', v[vv])['name']
                    break
                  case 'incOrExp':
                    res = getNameTextInOptions(this.optionsForIncOrExp, v[vv])
                    break
                  case 'capitalType':
                    res = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', v[vv])['name']
                    break
                  default:
                    res = v[vv]
                }
                return res
              })
            })
            import('../../plugins/xlsx/exportExcel').then(excel => {
              let tHeader = this.tableColumnList.map(v => v.title)
              try {
                excel.export_json_to_excel({
                  multiHeader2: [], // 这里是第一行的表头
                  multiHeader: [], // 这里是第二行的表头
                  header: tHeader, // 这里应该是算第三行的表头
                  data: dataRes,
                  merges: [],
                  filename: item.exportResultFileName
                })
                this.$message.success(item.exportSuccess)
                item.canExportOutFlag = true
                item.title = item.titleCopy
              } catch (err) {
                this.$message.error(item.exportError)
                item.canExportOutFlag = true
                item.title = item.titleCopy
              }
            })
            // end
          }
        })
        break
    }
  }

  // 删除：
  operationForDelete (id: string) {
    this
      .$confirm('确定要删除此收支流水记录吗?', '提示', {
        confirmButtonText: '确定删除',
        cancelButtonText: '取消删除',
        type: 'error'
      })
      .then(async () => {
        let { data: result } = await (this as any).$http.journalDelete({ id })
        if (result.code !== 200) return this.$message.error(result.msg)
        this.$message.success('删除成功！')
        this.getTableDataList()
      })
      .catch(() => {})
  }

  async getTableDataList () {
    try {
      const _that: any = this
      this.loading = true
      const pageParams = {
        pageNo: _that.currentPage,
        pageSize: _that.pageSize
      }
      const searchParams = disposeSearchParamsForCM(this.searchList, this.searchCheckList)
      const params = {
        ...pageParams,
        ...searchParams
      }
      const { data: result } = await (this as any).$http.journalQuery(params)
      this.loading = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = ((result.data && result.data.records) || []).map(item => {
        item.time = item.time.split(' ')[0]
        return item
      })
      _that.total = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  resetBtn () {
    this.searchList = this.searchList.map(item => {
      const { key } = item
      switch (key) {
        case 'organizationName':
          item.value = getAllFatherNodeForTree(this.treeDataForSubOrganatizion, 'children', 'id', this.userInfo.organizationId)
          break
        default:
          item.value = ''
          break
      }
      return item
    })
  }

  searchBtn (searchCheckListSelf) {
    let _that: any = this
    _that.currentPage = 1
    _that.pageSize = 10
    this.searchCheckList = searchCheckListSelf
    this.getTableDataList()
  }

  // 级联选择器：
  cascaderChooseChange (value) {
    // 拿到学校的id:
    let idForSchool = value[value.length - 1]
    let resForSchool = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', idForSchool)
    this.informationGenerateVoucher = this.informationGenerateVoucher.map(item => {
      const { key } = item
      switch (key) {
        case 'organizationNameForIncomeAndExpenses':
          item.temporaryStorageForValue = resForSchool
          break
      }
      return item
    })
  }

  async confirmGenerateVoucher () {
    try {
      let whoEmpty = null
      let isEmpty = this.informationGenerateVoucher.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      let api = ''
      let messageText = ''
      // 判断是生成还是清除：
      switch (this.titleForDialogFlagForGenerateVoucher) {
        case '生成凭证':
          api = 'journalGenerateProof'
          messageText = '生成凭证成功，请于凭证管理进行查看'
          break
        case '清除凭证':
          api = 'financeProofTruncate'
          messageText = '清除凭证成功，可重新生成凭证'
          break
      }
      this.loadingForGenerateVoucher = true
      const { data: result } = await (this as any).$http[api](disposeFillInfoToParamsForCM(this.informationGenerateVoucher))
      this.loadingForGenerateVoucher = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.dialogFlagForGenerateVoucher = false
    } catch (err) {
      console.log(err)
    }
  }

  async confirmGetJournalGenerateSubjectBalanceForm () {
    try {
      let whoEmpty = null
      let isEmpty = this.informationGetJournalGenerateSubjectBalanceForm.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      let api = ''
      let messageText = ''
      // 判断是生成还是清除：
      switch (this.titleForDialogFlagForGetJournalGenerateSubjectBalanceForm) {
        case '生成科目余额表':
          api = 'journalGenerateSubjectBalanceForm'
          messageText = '生成科目余额表成功，请于报表管理进行查看'
          break
        case '清除科目余额表':
          api = 'reportFormSubjectBalanceTruncate'
          messageText = '清除科目余额表成功，可重新生成科目余额表'
          break
      }
      this.loadingForGetJournalGenerateSubjectBalanceForm = true
      const { data: result } = await (this as any).$http[api](disposeFillInfoToParamsForCM(this.informationGetJournalGenerateSubjectBalanceForm))
      this.loadingForGetJournalGenerateSubjectBalanceForm = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.dialogFlagForGetJournalGenerateSubjectBalanceForm = false
    } catch (err) {
      console.log(err)
    }
  }

  // 结转：
  operationForCarryOver (): void {
    this.dialogFlagForCarryOver = true
    this.titleForDialogFlagForCarryOver = '结转'
  }

  // 清除结转数据：
  operationForEmptyCarryOver (): void {
    this.dialogFlagForCarryOver = true
    this.titleForDialogFlagForCarryOver = '清除结转数据'
  }

  async confirmForCarryOver () {
    try {
      let whoEmpty = null
      let isEmpty = this.informationCarryOver.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      let api = ''
      let messageText = ''
      // 判断是生成还是清除：
      switch (this.titleForDialogFlagForCarryOver) {
        case '结转':
          api = 'financeProofInOutTrans'
          messageText = '结转成功，请于凭证管理进行查看'
          break
        case '清除结转数据':
          api = 'financeProofInOutTransTruncate'
          messageText = '清除结转数据成功，可重新进行结转操作'
          break
      }
      this.loadingForCarryOver = true
      const { data: result } = await (this as any).$http[api](disposeFillInfoToParamsForCM(this.informationCarryOver))
      this.loadingForCarryOver = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.dialogFlagForCarryOver = false
    } catch (err) {
      console.log(err)
    }
  }

  // 生成总账：
  builderGeneralLedger () {
    this.dialogFlagForCommon = true
    this.titleForDialogFlagForCommon = '生成总账'
  }

  // 清空总账：
  emptyGeneralLedger () {
    this.dialogFlagForCommon = true
    this.titleForDialogFlagForCommon = '清空总账'
  }

  // 生成明细账：
  builderDetailAccount () {
    this.dialogFlagForCommon = true
    this.titleForDialogFlagForCommon = '生成明细账'
  }

  // 清空明细账：
  emptyDetailAccount () {
    this.dialogFlagForCommon = true
    this.titleForDialogFlagForCommon = '清空明细账'
  }

  async confirmForCommon () {
    try {
      let whoEmpty = null
      let isEmpty = this.informationCommon.some(item => {
        if (item.value === '' && item.isNecessary) {
          whoEmpty = item
          return true
        }
      })
      if (isEmpty) return this.$message.warning(whoEmpty.placeholder)
      let api = ''
      let messageText = ''
      // 判断是生成还是清除：
      switch (this.titleForDialogFlagForCommon) {
        case '生成总账':
          api = 'financeProofLedger'
          messageText = '生成总账成功，请于报表管理进行查看'
          break
        case '清空总账':
          api = 'financeProofLedgerTruncate'
          messageText = '清空总账成功，可重新生成总账'
          break
        case '生成明细账':
          api = 'financeProofLedgerDetail'
          messageText = '生成明细账成功，请于报表管理进行查看'
          break
        case '清空明细账':
          api = 'financeProofLedgerDetailTruncate'
          messageText = '清除明细账成功，可重新生成明细账'
          break
      }
      this.loadingForCommon = true
      const { data: result } = await (this as any).$http[api](disposeFillInfoToParamsForCM(this.informationCommon))
      this.loadingForCommon = false
      if (result.code !== 200) return this.$message.error(result.msg)
      this.$message.success(messageText)
      this.dialogFlagForCommon = false
    } catch (err) {
      console.log(err)
    }
  }
}
